import { HealthPlan } from '../../../../graphql/graphql';
import styles from './WorkplaceHealthPlan.module.scss';
import { Theme } from '../../../../Enums/Theme.enum';
import React, { useState } from 'react';
import { HealthPlanCode } from '../../../../Enums/HealthPlanCode.enum';
import WorkplaceHealthPlanEdit from './WorkplaceHealthPlanEdit';
import LinkButton from '../../../../Components/Button/LinkButton';

interface Props {
	item: HealthPlan;
	openCaseTypes: (healthPlanCode: HealthPlanCode) => void;
	onUpdate: () => Promise<void>;
}

const WorkplaceHealthPlan = ({ item, openCaseTypes, onUpdate }: Props) => {
	const [isEditSettingModalOpened, setIsEditSettingModalOpened] =
		useState(false);

	const handleOpenCaseTypes = async () => {
		openCaseTypes(item.code as HealthPlanCode);
	};

	const handleEditSuccess = async () => {
		setIsEditSettingModalOpened(false);
		return onUpdate();
	};

	return (
		<div className={styles.item}>
			<div className={styles.title}>
				<div>{item?.name}</div>
				<div className={styles.buttons}>
					{item?.code === HealthPlanCode.DENT && (
						<LinkButton
							title={'base.settings'}
							theme={Theme.BLUE}
							onClick={() => setIsEditSettingModalOpened(true)}
							firstUpper
						/>
					)}
					{item?.code && (
						<LinkButton
							title='base.caseTypes'
							theme={Theme.BLUE}
							onClick={handleOpenCaseTypes}
							firstUpper
						/>
					)}
				</div>
			</div>
			{isEditSettingModalOpened && (
				<WorkplaceHealthPlanEdit
					item={item}
					onClose={() => setIsEditSettingModalOpened(false)}
					onSuccess={handleEditSuccess}
				/>
			)}
		</div>
	);
};

export default WorkplaceHealthPlan;
